import Vue from 'vue';
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import { MUTATIONS, _SUBSTITUTE_TEACHER_STORE, INVITATION_TYPE } from '../values/substitute-teacher.values';
import { SubstituteTeacherService } from '../services/substitute-teacher.service';

export const SUBSTITUTE_TEACHER_STORE = _SUBSTITUTE_TEACHER_STORE;

@Module({ namespaced: true })
export class SubstituteTeacherStore extends VuexModule {

  /* State */
  public givenInvitations: any = []; 
  public receivedInvitations: any = [];

  /* Mutations */
  @Mutation
  public setGivenInvitationsM(data){
    let content = data.content
    let page = data.number
    this.givenInvitations = [...this.givenInvitations, {page, content}]
  }

  @Mutation
  public setReceivedInvitationsM(data){
    let content = data.content
    let page = data.number
    this.receivedInvitations = [...this.receivedInvitations, {page, content}]
  }

  @Mutation
  public resetTeacherInvitations(){
    this.givenInvitations = []
    this.receivedInvitations = []
  }

  /* Actions */
  @Action({rawError:true})
  public getSubstituteTeacherA({type,page=0,pageSize=10}:{type:string,page:number,pageSize:number}): Promise<any>{
    return new Promise((resolve,reject) => {
      SubstituteTeacherService.getSubstituteTeachersByType({type,page,pageSize}).then((res:any) => {
          if(type == INVITATION_TYPE.GIVEN)
            this.context.commit(MUTATIONS.SET_GIVEN_INVITATIONS_M, res);
          else 
            this.context.commit(MUTATIONS.SET_RECEIVED_INVITATIONS_M, res);
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }

  /* Initial State */
  @Mutation
  public initState(state) {
    this.givenInvitations = [];
    this.receivedInvitations = [];
  }

}
